module.exports = __webpack_public_path__ + "static/media/Asset 7.1@3x.39509816.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 7.1@3x.png
// module id = 2398
// module chunks = 0